exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".v-container[data-v-70305a28]{min-height:0}.flex .label[data-v-70305a28]:after{content:\":\"}", "", {"version":3,"sources":["/Users/wvl/Workspaces/NowYu/nowyu-we/src/pages/ProfileProvider.vue"],"names":[],"mappings":"AACA,8BACE,YAAc,CACf,AACD,oCACE,WAAa,CACd","file":"ProfileProvider.vue","sourcesContent":["\n.v-container[data-v-70305a28] {\n  min-height: 0;\n}\n.flex .label[data-v-70305a28]:after {\n  content: \":\";\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-70305a28","scoped":true,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/ProfileProvider.vue
// module id = 378
// module chunks = 0